import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-area--header" }
const _hoisted_2 = { href: "/" }
const _hoisted_3 = ["alt", "src", "srcset"]

import TopBar from '@/components/common/layoutWrappers/HeaderBar.vue';
import MegaMenu from '@/components/common/megaMenu/MegaMenu.vue';
import { useNavigationStore } from '@/stores/navigation.store';
import UserAreaActionsMenu from '@/components/userArea/UserAreaActionsMenu.vue';
import { useAppStore } from '@/stores/app.store';
import helpers from '@/helpers';
import useTranslations from '@/composables/useTranslations';
import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAreaHeader',
  setup(__props) {

const { translate: t } = useTranslations();
const navigationStore = useNavigationStore();
const appStore = useAppStore();

const logoImgUrl = helpers.url.outerUrl('/files/public/Logo/InnerLogo.png');
const isBigLogo = ref(false);

onMounted(() => {
  const img = new Image();
  img.onload = () => {
    if (img?.width > 320) {
      isBigLogo.value = true;
    }
  };
  img.src = logoImgUrl;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(TopBar, null, _createSlots({
      logo: _withCtx(() => [
        _createElementVNode("a", _hoisted_2, [
          _createElementVNode("img", {
            class: "logo-image",
            alt: _unref(t)('Menu.HomePage'),
            src: _unref(logoImgUrl),
            srcset: isBigLogo.value ? `${_unref(logoImgUrl)} 2x, ${_unref(logoImgUrl)} 1.5x, ${_unref(logoImgUrl)} 1x` : undefined
          }, null, 8, _hoisted_3)
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(UserAreaActionsMenu)
      ]),
      _: 2
    }, [
      (_unref(appStore)?.isMobile == false)
        ? {
            name: "mega-menu",
            fn: _withCtx(() => [
              _createVNode(MegaMenu, {
                "active-mega-menu-item-overwrite": _unref(navigationStore)?.userTopMenu?.menuItemActiveOverwrite,
                "mega-menu-items": _unref(navigationStore)?.userTopMenu.menuItemViewModels || []
              }, null, 8, ["active-mega-menu-item-overwrite", "mega-menu-items"]),
              _cache[0] || (_cache[0] = _createElementVNode("span", { id: "repo-selector" }, null, -1))
            ]),
            key: "0"
          }
        : undefined
    ]), 1024)
  ]))
}
}

})